import { getContactUserList, getDepartmentList, getGroupList, getRecentlyContactList, getSearchGlobal, getWorkLineList } from "../../../api/ebook";
import { SearchType, TabKeyType } from "../../../types";

export const getApi = {
    [TabKeyType.All]: ({keyword = '', searchType = SearchType.All, pageNo = 1, pageSize = 10}) => {
        let type = searchType;
        return getSearchGlobal(keyword, type, pageNo, pageSize)
    },
    [TabKeyType.RecentlyContact]: ({ pageId, start, length }: any) => getRecentlyContactList(pageId, start, length),
    [TabKeyType.Contact]: ({ start, length }: any) => getContactUserList(),
    [TabKeyType.Department]: ({ depId }:any) => getDepartmentList(depId, true),
    [TabKeyType.Groups]: () => getGroupList(),
    [TabKeyType.WorkLine]: ({ depId, isInit }: any) => getWorkLineList(depId, 0, isInit = isInit ? isInit : false),
}


